import React, { useState, useEffect, useRef } from "react";
import {
  Modal,
  TextInput,
  Button,
  Group,
  ColorInput,
  Text,
  Select,
} from "@mantine/core";
import classes from "./edit.module.css";
import { RowDataGames } from "./types";
import { Dropzone } from "@mantine/dropzone";
import { IconPhoto } from "@tabler/icons-react";

interface EditModalProps {
  isOpen: boolean;
  onClose: () => void;
  onEdit: (editedData: RowDataGames) => void;
  data: RowDataGames;
}

const EditGameModal: React.FC<EditModalProps> = ({
  isOpen,
  onClose,
  onEdit,
  data,
}) => {
  const [editedData, setEditedData] = useState<RowDataGames>(data);

  const imageDropzoneRef = useRef<() => void>(null);

  useEffect(() => {
    setEditedData(data);
  }, [data]);

  const handleImageUpload = (files: File[]) => {
    const file = files[0];
    if (file) {
        setEditedData({ ...editedData, img: file });
    }
  };

  const handleEdit = () => {
    // Perform validation or additional logic as needed
    onEdit(editedData);
    onClose();
  };

  return (
    <Modal
      title={
        <div style={{ textAlign: "center", fontWeight: "bold" }}>
          Edit Banner
        </div>
      }
      opened={isOpen}
      onClose={onClose}
    >
      <TextInput
        label="Game name"
        maxLength={255}
        mb="sm"
        value={editedData.name}
        onChange={(event) =>
            setEditedData({ ...editedData, name: event.currentTarget.value })
        }
      />

      <Text className={classes.Text}>
        Image <span className={classes.format}>(.jpg, .png)</span>
      </Text>
      <Dropzone
        onDrop={handleImageUpload}
        accept={["image/*"]}
        openRef={imageDropzoneRef}
      >
        <div className={classes.imageContainer}>
          {editedData.img ? (
            <img
              src={
                !editedData.img.path
                  ? editedData.img
                  : URL.createObjectURL(editedData.img)
              }
              alt="Image"
              className={classes.imageSize}
            />
          ) : (
            <p>
              <IconPhoto />
            </p>
          )}
        </div>
      </Dropzone>
      <Group>
        <Button
          onClick={() => imageDropzoneRef.current?.()}
          className={classes.imageButton}
        >
          <IconPhoto />
          Upload Image
        </Button>
      </Group>

      <Group className={classes.buttonBottom}>
        <Button onClick={() => onClose()} className={classes.buttonCancel}>
          Back
        </Button>
        <Button onClick={handleEdit} className={classes.buttonSaveChanges}>
          Save Changes
        </Button>
      </Group>
    </Modal>
  );
};

export default EditGameModal;
